import { EmailData } from './email-viewer-types';
import { Card, CardContent } from '@/components/ui/card';
import { EmailBodyView } from './email-body-content';
import { useEmailCidMap } from './use-email-cid-map';

export function EmailBody({ emailData }: { emailData: EmailData }) {
  const cidMap = useEmailCidMap(emailData);

  return (
    <Card>
      <CardContent className="min-w-0 bg-white text-gray-900">
        <EmailBodyView email={emailData} cidMap={cidMap} />
      </CardContent>
    </Card>
  );
}
